import React from 'react';
import SvgIcon from 'material-ui/SvgIcon';

const RefineIcon = props => (
  <svg
  style={props.style}
  xmlns="http://www.w3.org/2000/svg"
  width="30"
  height="30"
  fill="none"
  viewBox="0 0 30 30"
>
  <g>
    <path
      fill="#fff"
      d="M23.434 24.566a.8.8 0 001.132-1.132l-1.132 1.132zm-4.388-11.643a6.123 6.123 0 01-6.123 6.123v1.6a7.723 7.723 0 007.723-7.723h-1.6zm-6.123 6.123A6.123 6.123 0 016.8 12.923H5.2a7.723 7.723 0 007.723 7.723v-1.6zM6.8 12.923A6.123 6.123 0 0112.923 6.8V5.2A7.723 7.723 0 005.2 12.923h1.6zM12.923 6.8a6.123 6.123 0 016.123 6.123h1.6A7.723 7.723 0 0012.923 5.2v1.6zm4.973 12.227l5.538 5.539 1.132-1.132-5.539-5.538-1.131 1.131z"
    ></path>
  </g>
</svg>
);

export default RefineIcon;



// WEBPACK FOOTER //
// ./src/icons/RefineIcon.jsx